<template>
  <div class="min-h-screen bg-surface">
    <!-- Hero Section -->
    <Section class="pt-24 pb-16 bg-white">
      <div class="container mx-auto px-4 max-w-4xl">
        <h1 class="text-4xl md:text-5xl font-bold text-ink mb-6 text-center">
          Terms of Service
        </h1>
        <p class="text-lg text-muted text-center mb-8">
          Last updated: October 29, 2025
        </p>
      </div>
    </Section>

    <!-- Content Section -->
    <Section class="py-16">
      <div class="container mx-auto px-4 max-w-4xl">
        <div class="space-y-12">
          <!-- Use of the Service -->
          <div>
            <h2 class="text-2xl font-bold text-ink mb-4">Use of the Service</h2>
            <p class="text-muted">By using Easy To Manage, you agree to the following terms: You may use our service only if you have the legal authority to bind your organization. You must provide accurate information and comply with all applicable marketplace terms and policies.</p>
          </div>

          <!-- Brand Analytics Access -->
          <div>
            <h2 class="text-2xl font-bold text-ink mb-4">Brand Analytics Access</h2>
            <p class="text-muted">To deliver platform features, Easy To Manage connects to marketplace-provided brand analytics including search term reports, click and conversion metrics, and competitor comparisons. You authorize this access when you connect your marketplace accounts. This access can be revoked at any time, but certain insights may be disabled.</p>
          </div>

          <!-- Account Responsibility -->
          <div>
            <h2 class="text-2xl font-bold text-ink mb-4">Account Responsibility</h2>
            <p class="text-muted">You are responsible for safeguarding your account credentials. We are not liable for any loss or damage from unauthorized access due to your failure to maintain account security.</p>
          </div>

          <!-- Limitation of Liability -->
          <div>
            <h2 class="text-2xl font-bold text-ink mb-4">Limitation of Liability</h2>
            <p class="text-muted">Easy To Manage is not responsible for any direct or indirect losses resulting from marketplace changes, API limitations, or third-party data access errors.</p>
          </div>

          <!-- Modifications -->
          <div>
            <h2 class="text-2xl font-bold text-ink mb-4">Modifications</h2>
            <p class="text-muted">We may update these terms from time to time. You will be notified of significant changes. Continuing to use the platform after updates means you agree to the revised terms.</p>
          </div>

          <!-- Contact Information -->
          <div class="bg-gray-50 p-6 rounded-lg">
            <h2 class="text-2xl font-bold text-ink mb-4">Contact Information</h2>
            <p class="text-muted mb-3">Email: <a href="mailto:Info@easytomanage.com" class="text-brand hover:underline">Info@easytomanage.com</a></p>
            <p class="text-muted">Address: 681 Fifth Avenue, 14th Floor, New York, NY 10022</p>
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script setup lang="ts">
import Section from '@/components/Section.vue'
</script>